// extracted by mini-css-extract-plugin
module.exports = {"title":"image-description_title_1EHMw","component":"image-description_component_2bTft"};